import { render, staticRenderFns } from "./saveUpdate.vue?vue&type=template&id=0efe43e2"
import script from "./saveUpdate.vue?vue&type=script&lang=js"
export * from "./saveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports